import { NetworkRequest } from "api/actions";

export const getNotices = (): NetworkRequest => {
    return {
        type: "NETWORK_REQUEST",
        method: "GET",
        url: "/api/notices"
    };
};
